import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { VrstaKomitenta } from './vrsta-komitenta';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-vrsta-komitenta',
  templateUrl: './vrsta-komitenta.component.html'
})
export class VrstaKomitentaComponent extends BaseModalContainer<VrstaKomitenta> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaKomitenta>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
